/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionsupport3Inputs */



/**
* | output |
* | --- |
* | "You’re a safe harbor. You like taking care of your people, creating cozy spaces, and being that friend who will always listen, support, and actually ask how ..." |
*
* @param {Personalityarchetypedescriptionsupport3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionsupport3 = /** @type {((inputs?: Personalityarchetypedescriptionsupport3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionsupport3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You’re a safe harbor. You like taking care of your people, creating cozy spaces, and being that friend who will always listen, support, and actually ask how you’re doing.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eres un puerto seguro. Te gusta cuidar a tu gente, crear espacios acogedores y ser ese amigo que siempre escucha, apoya y realmente pregunta cómo estás.")
	return /** @type {LocalizedString} */ ("Ты — безопасная гавань. Тебе нравится опекать близких, создавать уют и быть тем самым другом, который всегда выслушает, поддержит и спросит, как дела.")
});
export { personalityarchetypedescriptionsupport3 as "personalityArchetypeDescriptionSupport" }